import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const vendorAPI = {
    create: async (vendorData) => {
        try {
            const { data } = await api.post('/api/vendors/create/', vendorData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create vendor error:');
        }
    },
    getAll: async (page, pageSize, searchTerm, showDeactivated) => {
        try {
            const { data } = await api.get('/api/vendors', {
                params: { page, pageSize, searchTerm, showDeactivated }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all vendors error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/vendors/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get vendor by id error:');
        }
    },
    update: async (id, vendorData) => {
        try {
            const { data } = await api.put(`/api/vendors/update/${id}/`, vendorData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update vendor error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/vendors/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete vendor error:');
        }
    }
};